import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rowsSintetico: [],
  rowsAnalitico: [],
  dataSintetico: [],
};

export const spedSlice = createSlice({
  name: "sped",
  initialState,
  reducers: {
    listarSpedEfdAnalitico(state, action) {
      return {
        ...state,
        rowsAnalitico: action.payload,
      };
    },
    listarSpedEfdSintetico(state, action) {
      return {
        ...state,
        rowsSintetico: action.payload,
      };
    },
    downloadSpedEfdSintetico(state, action) {
      return {
        ...state,
        dataSintetico: action.payload,
      };
    },
    resetSpedEfdAnalitico(state) {
      state.rowsAnalitico = [];
    },
  },
});

export const spedAction = spedSlice.actions;

export default spedSlice.reducer;
